import { T } from "../themes";

export default function Spinner({ size=14 }) {
  return (
    <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center"}}>
      <span style={{
        width:size,height:size,
        border:`2px solid ${T.surface}`,
        borderTop:`2px solid ${T.accent}`,
        borderRadius:"50%",
        display:"inline-block",
        animation:"np-spin 0.7s linear infinite",
      }}/>
    </span>
  );
}
